import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';

export const StarPossible = createIcon({
  d: 'M10.368 1.15l2.856 5.9 6.442.93-4.65 4.582 1.13 6.508-5.778-3.054-5.78 3.055 1.13-6.508-4.65-4.583L7.5 7.06z',
  viewBox: '0 0 20.731 19.998',
  displayName: 'StarPossible',
  defaultProps: {
    stroke: '#f0dd00',
  },
});
